// =============================================================================
// app/src/lib/campoNumerico.ts — Serginho Autopeças
// A regra de um campo de número que a pessoa ainda está DIGITANDO.
//
// O BUG QUE ISTO CONSERTA (relatado pelo dono em 17/08/2026): "o campo de
// colocar o valor na venda não está permitindo nem , nem .".
//
// A causa: o input era controlado pelo NÚMERO. A cada tecla o valor era
// convertido com paraNumero() e reescrito na tela. E paraNumero('12,') devolve
// `null` de propósito — "12," não é um número, é meio número. Com `?? 0` no
// caminho, digitar a vírgula ZERAVA o campo. O mesmo com o ponto.
//
// A regra, em uma frase: ENQUANTO SE DIGITA, O TEXTO MANDA. O número só volta
// a comandar a exibição quando o campo perde o foco — aí "12,50" vira o
// canônico "12,5" e some qualquer lixo que não formou número.
//
// Estados intermediários NÃO reportam valor nenhum ao pai: "12," mantém o 12
// que já estava, em vez de derrubar para zero. Só o campo VAZIO reporta
// "apagou" — porque aí a intenção é clara.
// =============================================================================

import { numeroParaTexto } from './desconto';
import { paraNumero } from './formato';

/** O que o campo mostra: o que está sendo digitado vence o número guardado. */
export function textoDoCampoNumerico(digitado: string | null, valor: number | null): string {
  if (digitado !== null) return digitado;
  return numeroParaTexto(valor);
}

export type LeituraCampo =
  /** Formou número: pode reportar ao pai. */
  | { tipo: 'numero'; valor: number }
  /** A pessoa apagou tudo — intenção clara de esvaziar. */
  | { tipo: 'vazio' }
  /** "12,", "12.", "-" ou lixo: meio caminho. NÃO mexe no valor guardado. */
  | { tipo: 'incompleto' };

/**
 * O que o campo reporta ao pai a cada tecla.
 *
 * O terceiro caso é o que faz a vírgula funcionar: sem ele, todo estado
 * intermediário viraria zero e a pessoa nunca chegaria a "12,50".
 */
export function lerCampoNumerico(texto: string): LeituraCampo {
  if (texto.trim() === '') return { tipo: 'vazio' };
  const n = paraNumero(texto);
  return n === null ? { tipo: 'incompleto' } : { tipo: 'numero', valor: n };
}
